import { useMutation } from '@tanstack/react-query';
import { apiClient, getEndpoints } from '../../common';

const TEAM_NAMESPACE = ['auth', 'teams'];

interface TeamAccessRequestActionInput {
	teamId: string;
	membershipId: string;
}

export function useApproveTeamAccessRequest() {
	return useMutation({
		mutationFn: async ({
			teamId,
			membershipId,
		}: TeamAccessRequestActionInput) => {
			const url = getEndpoints(TEAM_NAMESPACE).byPath([
				teamId,
				'access_requests',
				membershipId,
				'approve',
			]);
			const { data } = await apiClient.post(url);
			return data;
		},
	});
}

export function useRejectTeamAccessRequest() {
	return useMutation({
		mutationFn: async ({
			teamId,
			membershipId,
		}: TeamAccessRequestActionInput) => {
			const url = getEndpoints(TEAM_NAMESPACE).byPath([
				teamId,
				'access_requests',
				membershipId,
				'reject',
			]);
			const { data } = await apiClient.post(url);
			return data;
		},
	});
}
